import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "password",
  "use": "password-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"password\"><path d=\"M18.097 1L16.29 2.892m0 0L19 5.731l-3.16 3.311-2.71-2.838m3.16-3.312l-3.16 3.312m-3.712 3.888a5.223 5.223 0 0 1 1.091 1.689 5.42 5.42 0 0 1 .013 3.999 5.228 5.228 0 0 1-1.08 1.696 4.956 4.956 0 0 1-1.62 1.131 4.77 4.77 0 0 1-3.816-.013 4.96 4.96 0 0 1-1.612-1.143A5.339 5.339 0 0 1 1 13.791a5.33 5.33 0 0 1 1.455-3.634 4.857 4.857 0 0 1 3.469-1.524 4.85 4.85 0 0 1 3.494 1.46zm0 0l3.712-3.888\" stroke=\"#702F73\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/password.svg
// module id = 465
// module chunks = 0